import React from "react";
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic'
import { Link } from "react-router-dom";
import IMAGE1 from '../../assets/egitimedestek/1.jpeg';
import IMAGE2 from '../../assets/egitimedestek/2.jpeg';

const image3 = "https://gelecektupbebek.com.tr/eski/Egitime-Destek-Projemiz/Mus/1.jpeg";

export default function () {
    return (
        <S.Wrapper>
            <S.Sol>
                <Link to="/support" className="content-link">
                    <p className="title">
                        <b><TranslateStatic string="EgitimDestekLow1" /></b>
                        <TranslateStatic string="EgitimDestekLow2" />
                    </p>
                    <article className="desc">
                        <TranslateStatic string="EgitimArticle1" />
                    </article>
                    <br/>
                    <article className="desc">
                        <TranslateStatic string="EgitimArticle2" />
                    </article>
                    <button className="minimal-btn">
                        <TranslateStatic string="Ayrintilar" /> 
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                        </svg>
                    </button>
                </Link>
            </S.Sol>
            <S.Sag>
                <div className="bento-grid">
                    <div className="bento-card hero">
                        <img src={IMAGE1} alt="Eğitime Destek 1" />
                    </div>
                    <div className="bento-card top-right">
                        <img src={IMAGE2} alt="Eğitime Destek 2" />
                    </div>
                    <div className="bento-card bottom-right">
                        <img src={image3} alt="Eğitime Destek 3" />
                    </div>
                </div>
            </S.Sag>
        </S.Wrapper>
    );
}